import { StoreState } from "store/index";

export const getTrendingDestinations = (state: StoreState) => state.trendingDestinations;
